import React from 'react';
import { TestimonialCard } from '../ui/TestimonialCard';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Judah Medical Transport has been a lifesaver for my weekly dialysis appointments. Always on time, always professional.',
    author: 'Margaret T.',
    role: 'Recurring Patient',
    rating: 5
  }, {
    quote: 'The drivers are so kind and patient with my mother. We trust them completely.',
    author: 'David L.',
    role: 'Family Member',
    rating: 5
  }, {
    quote: 'Reliable, affordable, and compassionate. Highly recommend for anyone needing medical transport.',
    author: 'Sarah K.',
    role: 'Healthcare Provider',
    rating: 5
  }];
  return <section className="bg-white py-20" data-id="element-283">
      <div className="max-w-7xl mx-auto px-4" data-id="element-284">
        <div className="text-center mb-12" data-id="element-285">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0B1F3A] mb-6" data-id="element-286">
            What Our Clients Are Saying
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-287">
            Don't just take our word for it - hear from our satisfied patients
            and their families
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-288">
          {testimonials.map((testimonial, index) => <TestimonialCard key={index} {...testimonial} data-id="element-289" />)}
        </div>
      </div>
    </section>;
}